module.exports = __webpack_public_path__ + "static/profile-fcea061976cc4b9db435248371040449.jpg";